// Reject malformed admin responses rather than showing a false empty queue or crashing.
export const validateCourseApplication = value => {
  const textFields = ['business_id', 'course_name', 'status', 'city', 'state', 'contact_name'];
  if (!value || typeof value !== 'object' || !value.business_id || textFields.some(key => typeof value[key] !== 'string')) {
    throw new Error('Invalid course application response.');
  }
  return value;
};

export const validateCourseApplicationPage = value => {
  if (!value || !Array.isArray(value.applications) || !Number.isInteger(value.total) || value.total < value.applications.length) {
    throw new Error('Invalid course application list response.');
  }
  value.applications.forEach(validateCourseApplication);
  return value;
};